import en from './en.json';
import fa from './fa.json';

const dictionaries = { en, fa };

export function createI18nStore() {
  return {
    locale: localStorage.getItem('opshub_locale') || 'en',
    calPref: localStorage.getItem('chehrecrm_cal') || 'auto',
    dictionaries,

    get dir() {
      return this.locale === 'fa' ? 'rtl' : 'ltr';
    },

    t(key, params = {}) {
      const dict = this.dictionaries[this.locale] || this.dictionaries.en;
      let str = dict[key] || this.dictionaries.en[key] || key;
      Object.entries(params).forEach(([k, v]) => {
        str = str.replaceAll(`{${k}}`, v);
      });
      return str;
    },

    setLocale(locale) {
      if (!dictionaries[locale]) return;
      this.locale = locale;
      localStorage.setItem('opshub_locale', locale);
      document.documentElement.lang = locale;
      document.documentElement.dir = this.dir;
    },

    setCalPref(pref) {
      this.calPref = pref;
      if (pref === 'auto') {
        localStorage.removeItem('chehrecrm_cal');
      } else {
        localStorage.setItem('chehrecrm_cal', pref);
      }
    },

    resolvedCalendar() {
      if (this.calPref === 'jalali' || this.calPref === 'gregorian') return this.calPref;
      return this.locale === 'fa' ? 'jalali' : 'gregorian';
    },
  };
}
